import { format } from "date-fns";
import {
  QualityEventAnswers,
  QualityEventField,
  QualityEventRecord,
  qualityEventRows,
} from "src/types/quality-events";
import { isQualityEventConditionMet } from "./quality-event-conditions";

export const getQualityEventStatistics = (records: QualityEventRecord[]) => {
  const open = records.filter((record) => record.status !== "CLOSED");
  const today = format(new Date(), "yyyy-MM-dd");
  const isPastDue = (value: unknown) =>
    typeof value === "string" && value !== "" && value < today;
  const hasOverdueDeadline = (
    record: QualityEventRecord,
    fields: QualityEventField[],
    answers: QualityEventAnswers,
    allAnswers: QualityEventAnswers
  ): boolean => {
    const scope = { ...allAnswers, ...answers };
    return fields.some((field) => {
      if (!isQualityEventConditionMet(field.showWhen, scope)) return false;
      if (field.type === "repeatable") {
        const completionSource = field.task?.completedFrom;
        const completionRows = completionSource
          ? qualityEventRows(
              record.steps[completionSource.stepKey].answers[
                completionSource.fieldKey
              ]
            )
          : [];
        return qualityEventRows(answers[field.key]).some((row) => {
          const completionAnswers = completionRows.find(
            (item) => item.id === row.id
          )?.answers;
          return hasOverdueDeadline(
            record,
            field.fields,
            row.answers,
            completionAnswers ? { ...scope, ...completionAnswers } : scope
          );
        });
      }
      return (
        field.type === "date" &&
        !!field.deadline &&
        isPastDue(answers[field.key]) &&
        !field.deadline.resolvedWhen?.some((condition) =>
          isQualityEventConditionMet(condition, scope)
        )
      );
    });
  };
  return {
    open: open.length,
    inReview: records.filter((record) => record.status === "IN_REVIEW").length,
    closed: records.length - open.length,
    overdue: open.filter((record) => {
      const assignment = record.definition.definition.assignment;
      if (
        assignment?.dueDateField &&
        Object.values(record.steps).some((step) => !step.completedAt) &&
        isPastDue(
          record.steps[assignment.stepKey]?.answers[assignment.dueDateField]
        )
      )
        return true;
      const allAnswers = Object.assign(
        {},
        ...Object.values(record.steps).map((step) => step.answers)
      );
      return record.definition.definition.steps.some((step) =>
        hasOverdueDeadline(
          record,
          step.fields,
          record.steps[step.key]?.answers ?? {},
          allAnswers
        )
      );
    }).length,
  };
};
